export default "__VITE_ASSET__C3YndJ$b__"